import React from "react";

// set the defaults
const SelectedMenuContext = React.createContext(undefined)

export default SelectedMenuContext;
